import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const swiper = new Swiper(".results-swiper-init", {
  loop: false,

  slidesPerView: 1,
  slidesPerGroup: 1,
  spaceBetween: 20,
  centeredSlides: false,
  slidesOffsetBefore: 0,
  slidesOffsetAfter: 0,

  navigation: {
    nextEl: ".right-arrow-btn",
    prevEl: ".left-arrow-btn",
  },

  pagination: {
    el: ".results-swiper-pagination",
    clickable: true,
  },

  breakpoints: {
    768: {
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 30,
    },

    1440: {
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: 30,
    },
  },
});

document
  .querySelectorAll(".left-arrow-btn, .right-arrow-btn")
  .forEach((button) => {
    button.addEventListener("click", () => {
      button.blur();
    });
  });